import React, { Component } from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import Collapsible from "react-collapsible";
import { Col, Row } from "styled-bootstrap-grid";
import { CaretDown } from "styled-icons/boxicons-regular/CaretDown";
import { CaretUp } from "styled-icons/boxicons-regular/CaretUp";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import working from "./Icons/workinghours.svg";
import requested from "./Icons/requested hours.svg";
import tablet from "./Icons/tablet hours.svg";
import ProfilePic from "../../../Header/profile-pic-header.png";
import {
  TimeConverstion,
  dateFormat,
} from "../../../../../Api/Utils/ReuseableFunctions";
import Footer from "../../../../Shared/Footer";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import { ChevronLeft, ChevronRight } from "styled-icons/boxicons-regular";
import { format, isToday } from "date-fns";
import { updateManagerTimesheetData } from "../../../../../Actions";
import { TextArea } from "../../../../Shared/FormFields";
import { showModal, hideModal } from "../../../../../Actions";

class ManagerOneDayView extends Component {
  constructor(props) {
    super(props);
    this.dateData = undefined;
    this.reqHour = 0;
    this.reqTimeForTime = 0;
    this.reqPayment = 0;
    this.callOutHours = 0;
    this.callOutKilloMeters = 0;
    this.state = {
      collapsed: false,
      data: undefined,
      showModal: false,
      editMode: true,
      hidden: false,
    };
  }
  handleFormChange = (value, name) => {
    let data = JSON.parse(JSON.stringify(this.state.data));
    data.hoursDetail[name] = value;
    this.setState({ data });
  };
  saveFunc = () => {
    this.setState({
      editMode: false,
      hidden: true,
    });
    this.props.saveManagerCommentCreated(true);
    let payload = {
      timesheetRequestList: [
        {
          ssoId: this.props.hourData.ssoId,
          timesheetDate: this.props.hourData.requestedDate,
          timesheetAdditionalHour: Number(this.props.hourData.additionalHours),
          branchNumber: this.props.branchId,
          comments: this.props.hourData.hoursDetail.comments,
          managerComments: this.state.data.hoursDetail.managerComments,
          isApproved: "N",
          onHold: "N",
          maintainenceUser: this.props.ssoId,
          isStandBy: this.state.data.hoursDetail.isStandBy,
        },
      ],
    };
    this.props.dispatch(updateManagerTimesheetData(payload));
  };
  componentDidMount() {
    if (this.props.hourData.requestedDate !== void 0) {
      this.dateData = dateFormat(this.props.hourData.requestedDate);
      this.setState({
        data: this.props.hourData,
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.hourData !== prevProps.hourData) {
      this.dateData = dateFormat(this.props.hourData.requestedDate);
      if (this.props.hourData.hoursDetail !== void 0) {
        this.calculateRequestedHours();
        this.setState({
          data: this.props.hourData,
        });
      }
    }
  }
  calculateRequestedHours() {
    let reqPayment = 0;
    let reqTimeForTime = 0;
    let callOutHours = 0;
    let callOuts = this.props.hourData.hoursDetail.callOuts;
    let timeSheetAdd = this.props.hourData.hoursDetail.timeSheetAddtnlHours;
    this.callOutKilloMeters = 0;
    if (callOuts && callOuts.length) {
      for (let i = 0; i < callOuts.length; i++) {
        if (callOuts[i].paymentType === "P") {
          reqPayment = reqPayment + callOuts[i].callOutHours;
        } else if (callOuts[i].paymentType === "T") {
          reqTimeForTime = reqTimeForTime + callOuts[i].callOutHours;
        }
        callOutHours = callOutHours + callOuts[i].callOutHours;
        this.callOutKilloMeters =
          this.callOutKilloMeters +
          callOuts[i].calloutHomeToBusiness +
          callOuts[i].calloutBusinessToBusiness;
      }
    } else {
      this.callOutKilloMeters = 0;
    }
    if (this.props.hourData.hoursDetail.paymentType === "T") {
      reqTimeForTime = reqTimeForTime + timeSheetAdd;
    } else if (this.props.hourData.hoursDetail.paymentType === "P") {
      reqPayment = reqPayment + timeSheetAdd;
    }

    this.callOutHours = TimeConverstion(callOutHours);

    this.reqHour = TimeConverstion(callOutHours + timeSheetAdd);

    this.reqTimeForTime = TimeConverstion(reqTimeForTime);
    this.reqPayment = TimeConverstion(reqPayment);
  }
  requestedHour = () => {
    const { editMode, hidden, data } = this.state;
    return (
      <>
        <WrapperHours>
          <ColHeah>
            <ImageSpanHours>
              <img src={requested} alt="requested" />
            </ImageSpanHours>
            <HoursSpan>
              <Trans>requestedHours</Trans> <br />
              {this.reqHour}
            </HoursSpan>
          </ColHeah>
          <ROW>
            {this.props.security && this.props.security.timeForTime !== "T" && (
              <Col  md ="5">
                <Trans>under/overTime</Trans>
                <br />
                {this.reqPayment}
              </Col>
            )}
            {this.props.security && this.props.security.timeForTime !== "N" && (
              <Col md="4">
                <Trans>timeForTime</Trans>
                <br />
                {this.reqTimeForTime}
              </Col>
            )}
            <Col md="3">
              <Trans>absence</Trans>
              <br />
              {this.state.data.hoursDetail.isAbsent === "Y"
                ? TimeConverstion(this.state.data.hoursDetail.absentHours)
                : "__"}
            </Col>
          </ROW>
        </WrapperHours>
        <HoursOtherDetail>
          <div className="scroll-hour">
          {this.requestedHourDetails()}
          {this.calloutDetails()}
          </div>
          {this.commentDetails(editMode, hidden, data)}

        </HoursOtherDetail>
      </>
    );
  };
  requestedHourDetails = () => {
    return (
      <ROW className="margin-top">
        <Col md="4">
          <Trans>standBy</Trans>
          <br />
          {this.state.data.hoursDetail.isStandBy}
        </Col>
        <Col md="4">
          <Trans>callOutHours</Trans>
          <br />
          {this.callOutHours}
        </Col>
        <Col md="4">
          <Trans>kilometers</Trans>
          <br />
          {this.callOutKilloMeters}{" "}
        </Col>
      </ROW>
    );
  };
  commentDetails = (editMode, hidden, data) => {
    const { t } = this.props;
    return (
      <CommentPan>
          {/* <div> */}
          <Trans>technician</Trans> <Trans>comments</Trans>:
            {/* </div> */}
          <Comment>{this.state.data.hoursDetail.comments}</Comment>


          {/* {(this.state.data.hoursDetail.isApproved === "Y" ||
            this.state.editMode === false) && (
              <div>
                <Trans>manager</Trans> <Trans>comments</Trans>:
                <Comment>{data.hoursDetail.managerComments}</Comment>
              </div>
            )} */}

          {this.state.data.hoursDetail.isApproved !== "Y" && (
            <DivCommentSave>
              <TextArea
                placeholder={t("managerComments")}
                name="managerComments"
                //value={this.state.data.hoursDetail.managerComments || ""}
                value={
                  this.state.data.hoursDetail.managerComments
                    ? this.state.data.hoursDetail.managerComments
                    : ""
                }
                editMode={editMode}
                hidden={hidden}
                handleChange={(e) => {
                  this.handleFormChange(e.target.value, e.target.name);
                }}
              />
              <BtnSave onClick={this.saveFunc} hidden={hidden}>
                Save
                </BtnSave>
            </DivCommentSave>
          )}
        </CommentPan>
    );
  };

  calloutDetails = () => {
    // const { t } = this.props
    return (
      <div className="analysisDiv">
        <div className="CalloutDiv">
          <ROW>
            <Col md="4">
              <Trans>callOut</Trans>#
          </Col>
            <Col md="4">
              <Trans>kilometers</Trans>
            </Col>
            <Col md="4">
              <Trans>hours</Trans>
            </Col>
          </ROW>
          <div className="callouts">
            {this.state.data.hoursDetail.callOuts.map((data, index) => (
              <ROW key={"Callout" + index}>
                <Col md="4">{data.callOutNr}</Col>
                <Col md="4">
                  {data.calloutBusinessToBusiness + data.calloutHomeToBusiness}
                  </Col>
                <Col md="4">{TimeConverstion(data.callOutHours)}</Col>
              </ROW>
            ))}
          </div>
        </div>
        <div className="scheduledDiv">
        <ROW>
        <Col md="6" className="headings">
          <Trans>scheduledHours</Trans> <br />
          </Col>
        </ROW>
          <ROW>
            <Col md="3">
              <Trans>startTime</Trans>
          </Col>
            <Col md="3">
              <Trans>endTime</Trans>
            </Col>
            <Col md="3">
              <Trans>unpaidBreaks</Trans>
            </Col>
            <Col md="3">
              <Trans>paidBreaks</Trans>
            </Col>
          </ROW>
          {this.state.data.hoursDetail.scheduleStartTime ?(
          <div className="callouts">
              <ROW>
                <Col md="3">{this.state.data.hoursDetail.scheduleStartTime}</Col>
                <Col md="3">{this.state.data.hoursDetail.scheduleEndTime}</Col>
                <Col md="3">{TimeConverstion(this.state.data.hoursDetail.scheduleUnpaidBreak)}</Col>
                <Col md="3">{TimeConverstion(this.state.data.hoursDetail.schedulePaidBreak)}</Col>
              </ROW>
          </div>
          ): ("")}
        </div>
        {/* {this.state.data.tabletSummary.loginDetails.length>0 ?( */}
        <div className="scheduledDiv">
        <ROW>
        <Col md="6" className="headings">
          <Trans>actualHours</Trans> <br />
          </Col>
        </ROW>
          <ROW>
            <Col md="3">
              <Trans>startTime</Trans>
          </Col>
            <Col md="3">
              <Trans>endTime</Trans>
            </Col>
            <Col md="3">
              <Trans>unpaidBreaks</Trans>
            </Col>
            <Col md="3">
              <Trans>paidBreaks</Trans>
            </Col>
          </ROW>
          {this.state.data.hoursDetail.actualStartTime ?(
          <div className="callouts">
              <ROW>
                <Col md="3">{this.state.data.hoursDetail.actualStartTime}</Col>
                <Col md="3">{this.state.data.hoursDetail.actualEndTime}</Col>
                <Col md="3">{TimeConverstion(this.state.data.hoursDetail.actualUnpaidBreak)}</Col>
                <Col md="3">{TimeConverstion(this.state.data.hoursDetail.actualPaidBreak)}</Col>
              </ROW>
          </div>
          ): ("")}
        </div>
        <div className="scheduledDiv">
        <ROW>
        <Col md="6" className="headings">
          <Trans>approvedHours</Trans> <br />
          </Col>
        </ROW>
          <ROW>
            <Col md="3">
              <Trans>startTime</Trans>
          </Col>
            <Col md="3">
              <Trans>endTime</Trans>
            </Col>
            <Col md="3">
              <Trans>unpaidBreaks</Trans>
            </Col>
            <Col md="3">
              <Trans>paidBreaks</Trans>
            </Col>
          </ROW>
          {this.state.data.hoursDetail.approvedStartTime ?(
          <div className="callouts">
              <ROW>
                <Col md="3">{this.state.data.hoursDetail.approvedStartTime}</Col>
                <Col md="3">{this.state.data.hoursDetail.approvedEndTime}</Col>
                <Col md="3">{TimeConverstion(this.state.data.hoursDetail.approvedUnpaidBreak)}</Col>
                <Col md="3">{TimeConverstion(this.state.data.hoursDetail.approvedPaidBreak)}</Col>
              </ROW>
          </div>
          ): ("")}
        </div>
        {/* ): ("")} */}
        
      </div>
    );
  };

  closeModal = () => {
    this.props.dispatch(hideModal());
  };

  WorkPackDetails = () => {
    return (
      <ScrollOuterDiv className="fullHeight">
        <ROW className="tabel-row">
          <Col md="4">
            <Trans>workpackTask</Trans>
          </Col>
          <Col md="2">
            <Trans>unit</Trans>
          </Col>
          <Col md="2">
            <Trans>Start</Trans>
          </Col>
          <Col md="2">
            <Trans>finish</Trans>
          </Col>
          <Col md="2">
            <Trans>hours</Trans>
          </Col>
        </ROW>
        <ScrollInnerDiv>
          {this.state.data.workDetails.workedList.map((data, index) => (
            <ROW key={data.workPackTask + index} className="tabel-row">
              <Col md="4">{data.workPackTask}</Col>
              <Col md="2"> {data.unit}</Col>
              <Col md="2">{data.startTime}</Col>
              <Col md="2">{data.finishTime}</Col>
              <Col md="2">{TimeConverstion(data.hours)}</Col>
            </ROW>
          ))}
        </ScrollInnerDiv>
      </ScrollOuterDiv>
    );
  };
  BreakDetails = () => {
    return (
      <ScrollOuterDiv className="fullHeight">
        <ROW className="tabel-row">
          <Col md="4">
            <Trans>breaks</Trans>
          </Col>
          <Col md="3">
            <Trans>startTime</Trans>
          </Col>
          <Col md="3">
            <Trans>finishTime</Trans>
          </Col>
          <Col md="2">
            <Trans>hours</Trans>
          </Col>
        </ROW>
        <ScrollInnerDiv>
          {this.state.data.workDetails.breakList.map((data, index) => (
            <ROW key={"breakTime" + index} className="tabel-row">
              <Col md="5">{data.breakType}</Col>
              <Col md="2">{data.startTime}</Col>
              <Col md="3">{data.finishTime}</Col>
              <Col md="2">{TimeConverstion(data.hours)}</Col>
            </ROW>
          ))}
        </ScrollInnerDiv>
      </ScrollOuterDiv>
    );
  };
  workingHoursDetail = () => {
    const { t } = this.props;
    return (
      <Collapsible
        transitionTime={10}
        onOpening={() =>
          this.setState((state) => ({
            collapsed: !state.collapsed,
          }))
        }
        onClosing={() =>
          this.setState((state) => ({
            collapsed: !state.collapsed,
          }))
        }
        triggerTagName="div"
        trigger={
          <WrapperHours>
            <ColHeah>
              <ImageSpanHours>
                <img src={working} alt="working" />
              </ImageSpanHours>
              <HoursSpan>
                <Trans>workingHourDetail</Trans> <br />
                {TimeConverstion(this.state.data.workDetails.workingHour)}
              </HoursSpan>
            </ColHeah>
            <ROW>
              <Col md="6">
                <Trans>workingLunchBreak</Trans>
                <br />
                {TimeConverstion(this.state.data.workDetails.lunchBreak)}
              </Col>
              <Col md="6">
                <Trans>workingOtherBreaks</Trans>
                <br />
                {TimeConverstion(this.state.data.workDetails.otherBreak)}
              </Col>
            </ROW>
            <CollapseAct>
              {this.state.collapsed && <CaretUp className="caret" size="20" />}
              {!this.state.collapsed && <CaretDown size="20" />}
            </CollapseAct>
          </WrapperHours>
        }
      >
        <HoursOtherDetail>
          <WorkDetails>
            <Tabs activeKey={this.state.activeTab} onSelect={this.handleSelect}>
              <TAB eventKey={1} title={t("worked")}>
                {this.WorkPackDetails()}
              </TAB>
              <TAB eventKey={2} title={t("breaks")}>
                {this.BreakDetails()}
              </TAB>
            </Tabs>
          </WorkDetails>
          <TotalHoursPan>
            <Col md="6">
              <Trans>workedHours</Trans>
              <br />
              {TimeConverstion(this.state.data.workDetails.workedHours)}
            </Col>
            <Col md="6">
              <Trans>paidBreak</Trans>
              <br />
              {TimeConverstion(this.state.data.workDetails.paidBreak)}
            </Col>
          </TotalHoursPan>
        </HoursOtherDetail>
      </Collapsible>
    );
  };
  approveData = () => {
    let payload = {
      timesheetRequestList: [
        {
          ssoId: this.props.hourData.ssoId,
          timesheetDate: this.props.hourData.requestedDate,
          timesheetAdditionalHour: Number(this.props.hourData.additionalHours),
          branchNumber: this.props.branchId,
          comments: this.props.hourData.hoursDetail.comments,
          managerComments: this.state.data.hoursDetail.managerComments,
          isApproved: "Y",
          onHold: "N",
          maintainenceUser: this.props.ssoId,
          isStandBy: this.state.data.hoursDetail.isStandBy,
        },
      ],
    };

    let modalProps = {
      open: true,
      payload: payload,
      serviceName: updateManagerTimesheetData,
      closeModal: this.closeModal,
    };
    let template = "Manager/ConfirmBox/index";
    this.props.dispatch(showModal({ modalProps, template }));
    this.props.saveManagerCommentCreated(false);
  };
  holdData = () => {
    let payload = {
      timesheetRequestList: [
        {
          ssoId: this.props.hourData.ssoId,
          timesheetDate: this.props.hourData.requestedDate,
          timesheetAdditionalHour: Number(this.props.hourData.additionalHours),
          branchNumber: this.props.branchId,
          comments: this.props.hourData.hoursDetail.comments,
          managerComments: this.state.data.hoursDetail.managerComments,
          isApproved: "N",
          onHold: "Y",
          maintainenceUser: this.props.ssoId,
          isStandBy: this.state.data.hoursDetail.isStandBy,
        },
      ],
    };
    // let modalProps = {
    //   open: true,
    //   payload: payload,
    //   serviceName: updateManagerTimesheetData,
    //   closeModal: this.closeModal
    // };
    // let template = "Manager/ConfirmBox/index";
    // this.props.dispatch(showModal({ modalProps, template }));
    this.props.dispatch(updateManagerTimesheetData(payload));
    this.props.saveManagerCommentCreated(true);
  };
  tabletHours = () => {
    return (
      <>
        <WrapperHours>
          <ColHeah>
            <ImageSpanHours>
              <img src={tablet} alt="tablet" />
            </ImageSpanHours>
            <HoursSpan>
              <Trans>tabletHours</Trans> <br />
              {TimeConverstion(this.state.data.tabletSummary.tabletHour)}
            </HoursSpan>
          </ColHeah>
          <ROW>
            <Col>
              <Trans>contactedShiftHours</Trans>
              <br />
              {this.state.data.tabletSummary.contactedShiftHours}
            </Col>
          </ROW>
        </WrapperHours>
        <HoursOtherDetail>
          <ScrollOuterDiv className="margin-top">
            <ROW>
              <Col md="4">
                <Trans>login</Trans>
              </Col>
              <Col md="4">
                <Trans>logout</Trans>
              </Col>
            </ROW>
            <ScrollInnerDiv>
              {this.state.data.tabletSummary.loginDetails.map((data, index) => (
                <ROW key={"login" + index}>
                  <Col md="4">{data.loginTime}</Col>
                  <Col md="4">{data.logoutTime}</Col>
                  <Col md="2">{TimeConverstion(data.duration)}</Col>
                </ROW>
              ))}
            </ScrollInnerDiv>
            <TotalHoursTabletPan>
              <Col md="4">
                <Trans>totalHours</Trans>
                <br />
                {TimeConverstion(this.state.data.tabletSummary.totalHour)}
              </Col>
              <Col md="4">
                <Trans>lunchBreak</Trans> <br />
                {TimeConverstion(this.state.data.tabletSummary.lunchBreak)}
              </Col>
              <Col md="4">
                <Trans>available</Trans>
                <br />
                {TimeConverstion(this.state.data.tabletSummary.available)}
              </Col>
            </TotalHoursTabletPan>
          </ScrollOuterDiv>

        </HoursOtherDetail>
      </>
    );
  };
  Back = () => {
    this.props.history.goBack();
  };
  render() {
    const { security } = this.props
    return this.dateData !== void 0 && this.state.data !== void 0 ? (
      <ParentDiv>
        <ROW className="page-width">
          <Col md="4">
            <ProfileImage>
              <img src={ProfilePic} alt="profileimage" /> {"  "}
              {this.state.data.emplName}
              {security !== void 0 && security.showTimeForTimeBank !== "N" && (
                <ul>
                  <li>
                    <Trans>time4TimeBanked</Trans>
                  </li>
                  <li>
                    {this.state.data.hoursDetail.time4TimeBank
                      ? TimeConverstion(this.state.data.hoursDetail.time4TimeBank)
                      : "00"}
                  </li>
                </ul>
              )}
            </ProfileImage>
          </Col>
          <Col md="4">
            <CalenderDate>
             {this.props.startData<this.dateData&& <button className="buttonLeft" onClick={this.props.previousDay}>
                <ChevronLeft className="chevron" size="24" />{" "}
              </button>}
              {!isToday(this.dateData) &&  (this.props.endData>this.dateData || isNaN(this.props.endData.getTime())) && (
                <button
                  className="buttonRight"
                  type="submit"
                  onClick={this.props.nextDay}
                >
                  <ChevronRight className="chevron" size="24" />
                </button>
              )}
              
              <div>{format(this.dateData, "EEEE, dd MMM yyyy")}</div>
            </CalenderDate>
          </Col>
          <Col md="4">
            <div className="Time4Time">

              {this.state.data.hoursDetail.isApproved !== "Y" &&
                !isToday(dateFormat(this.state.data.requestedDate)) && (

                  <EditData onClick={this.props.editData}>
                    <Trans>editData</Trans>
                  </EditData>

                )}

              {this.state.data.hoursDetail.isApproved !== "Y" &&
                !isToday(dateFormat(this.state.data.requestedDate)) && (

                  <EditData onClick={this.props.sameDay}>
                    <Trans>recalculateData</Trans>
                  </EditData>

                )}

            </div>
          </Col>
        </ROW>
        <ParentDivView className="page-width">
          <ContPan>{this.requestedHour()}</ContPan>
          <ContPanMid collapsed={this.state.collapsed}>
            {" "}
            {this.workingHoursDetail()}
          </ContPanMid>
          <ContPan>{this.tabletHours()}</ContPan>
        </ParentDivView>
        <Footer>
          <BackButton onClick={this.Back}>
            <Trans>back</Trans>
          </BackButton>
          {!isToday(dateFormat(this.state.data.requestedDate)) && (
            <>
              {this.state.data.hoursDetail.isOnHold !== "Y" &&
                this.state.data.hoursDetail.isApproved !== "Y" && (
                  <HoldButton
                    onClick={this.holdData}
                    disabled={
                      this.state.data.hoursDetail.isTimesheetMissing === "Y"
                    }
                  >
                    <Trans>hold</Trans>
                  </HoldButton>
                )}
              {this.state.data.hoursDetail.isApproved !== "Y" && (
                <ApproveButton
                  disabled={
                    this.state.data.hoursDetail.isTimesheetMissing === "Y"
                  }
                  onClick={this.approveData}
                >
                  <Trans>approve</Trans>
                </ApproveButton>
              )}{" "}
            </>
          )}
        </Footer>
      </ParentDiv>
    ) : (
        <div />
      );
  }
}

const mapStateToProps = ({
  auth,
  userMessage,
  hourAnalytics,
  fetchTimesheetSecurity,
}) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    branchId: auth.user ? auth.user.defaultProfile.branchId : null,
    hourData: hourAnalytics.payload,
    security: fetchTimesheetSecurity.securityList,
  };
};
export default withRouter(
  connect(mapStateToProps)(withTranslation()(ManagerOneDayView))
);

const CalenderDate = styled.div`
  max-width: 300px;
  margin: 0 auto;
  margin-top: 5px;
  button {
    height: 24px;
    width: 24px;
    border-radius: 20px;
  }

  .buttonLeft {
    float: left;
  }
  .buttonRight {
    float: right;
  }
  .chevron {
    position: relative;
    right: 8px;
    bottom: 4px;
    background: #b7b7b7;
    border-radius: 20px;
  }
`;
const TotalHoursTabletPan = styled.div` background: #f1f4f9;
border-bottom-left-radius: 7px;
border-bottom-right-radius: 7px;
padding: 5px 0;
margin: 0 -10px;
position: absolute;
bottom: 10px;
width: 31%;
display: flex;
position: absolute;`
const ParentDiv = styled.div`
.analysisDiv{
  flex: 1 1 auto;
}
.CalloutDiv{
  margin-top: 2px;
  margin-bottom: 5px;
  height: 17%;
  overflow-y: scroll;
}
.scheduledDiv{
  margin-top: 5px;
  height: 25%;
}
.headings{
  font-weight: bold;
  font-size: 13px;
}
.callouts{
  overflow-y: scroll;
   overflow-x: hidden; 
  line-height: 26px;
}
ul {
  width: 50%;
  list-style-type: none;
  padding-left: 25px;
  margin: 0;
  text-align:left;
}
  display: flex;
  flex-direction: column;
  height: 100%;
  .margin-top {
    margin-top: 15px;
  }
  .fullHeight {
    height: 100%;
    padding-top: 7px;
  }
  .tabel-row {
    padding: 5px 0;
    line-height: 15px;
  }
  .page-width {
    min-width: 800px;
    width: 90%;
    max-width: 1290px;
    margin: 0 auto;
  }
  .scroll-hour{
    margin-top: 2px;
    height: 68%;
    overflow-y: scroll;
  }
`;
const ParentDivView = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1 1 auto;
  padding-bottom: 10px;
  position: relative;
  font-family: Trebuchet MS;
  font-size: 12px;
  text-align: left;
  line-height: 22px;
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 2px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: #343a40;
  }
`;
const ContPan = styled.div`
  width: 31%;
  box-shadow: 1px 3px 4px 1px #eaeaea;
  padding-left: 0px;
  padding-right: 0px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  display: flex;
  flex-direction: column;
`;
const ContPanMid = styled(ContPan)`
height : ${(props) => (!props.collapsed ? "115px" : "auto")}
min-height : ${(props) => (!props.collapsed ? "115px" : "50px")}
  width: 35%;
  .Collapsible{
    height:100%;
    display:flex;
    flex-direction:column;
  }
  .Collapsible__trigger.is-open + .Collapsible__contentOuter{
    height: 100% !important;
    }
  .Collapsible__contentInner{
    height:100%;
  }
`;
const WrapperHours = styled.div`
  background: #f1f4f9;
  height: 115px;
  padding: 0 10px;
`;
const ColHeah = styled.div`
  padding: 5px 10px 5px 10px;
  height: auto;
  &&:after {
    content: "";
    display: table;
    clear: both;
  }
`;
const HoursSpan = styled.span`
  font-size: 15px;
  text-align: left;
  font-family: Trebuchet MS;
  float: left;
  margin-left: 20px;
`;
const ImageSpanHours = styled.span`
  float: left;
  margin-top: 6px;
`;
const HoursOtherDetail = styled.div`
  flex: 1 1 0;
  padding: 0 10px 0 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const ScrollOuterDiv = styled.div`
  padding: 0 0 10px 0;
  // flex: 1 1 0;
  height:90%;
  display: flex;
  flex-direction: column;
`;
const ScrollInnerDiv = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  // flex: 1 1 0;
  height:79%;
  line-height: 26px;
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 2px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: #343a40;
  }
`;
const CommentPan = styled.div`
height: 85px;
padding: 0 10px;
position: absolute;
bottom: 0;
width: 30%;

`;

const Comment = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 25px;
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 2px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: #343a40;
  }
`;
const DivCommentSave = styled.div`
  padding-top: 6px;
  position: relative;
`;
const BtnSave = styled.button`
  background: #c4151c;
  color: #ffffff;
  border: 1px solid #adb5bd;
  width: 45px;
  height: 26px;
  border-radius: 50px;

  position: absolute;
  bottom: 20px;
  right: 0;
`;
const CollapseAct = styled.div`
  height: 20px;
  width: 20px;
  float: right;
  margin-top: -22px;
  .caret {
    color: grey;
  }
`;
const WorkDetails = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  margin: 15px -10px 0 -10px;
  border: none;
  text-align: left;
  .nav {
    border-bottom: none;
  }
  .nav.nav-tabs {
    height: 33px;
  }
  div.tab-content {
    padding-top: 0px;
  }
  .nav-tabs .nav-link {
    border: none;
    border-top-left-radius: 0px;
    border-top-right-radius: opx;
    color: #7e7e7e;
    height: 33px;
  }
  .nav-tabs .nav-item.show .nav-link,
  .nav-tabs .nav-link.active {
    height: 33px;
    border-bottom: 2px solid #00a6eb;
    color: #495057;
    background: none;
  }
`;
const TotalHoursPan = styled(Row)`
  background: #f1f4f9;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  padding: 5px 0;
  margin: 0 -10px;

`;
const ProfileImage = styled.div`
  text-align: left;
  padding-bottom: 0%;
  display:flex;
`;
const EditData = styled.button`
  width: auto;
  height: 40px;
  border: 1px solid #707071;
  background: white;
  border-radius: 20px;
  color: #707071;
  float: right;
  padding: 5px 25px 5px 25px;
  margin-left:10px;
`;
const ROW = styled(Row)`
  margin-right: 0px;
  margin-left: 0px;
`;
const TAB = styled(Tab)`
  font-size: 12px;
  font-family: Trebuchet MS;
`;
const Button = styled.button`
  width: 130px;
  height: 35px;
  border-radius: 50px;
  font-size: 12px;
  margin: 0 10px;
`;
const BackButton = styled(Button)`
  border: 2px solid #e0e0e0;
  background: #ffffff;
  color: #434f5b;
`;
const HoldButton = styled(Button)`
  border: 2px solid #e0e0e0;
  background: #ffffff;
  color: #434f5b;
`;
const ApproveButton = styled(Button)`
  background: ${(props) => (props.disabled ? "#ffffff" : "#c4151c")}
  color:${(props) => (props.disabled ? "#434f5b" : "#ffffff")} ;
  border: none;
  font-weight: 50;
`;
